import { Injectable } from '@angular/core';
import { SecurityAccessConstants } from '../../utils/constants/endpoints/security-access/security-access-constants';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  constructor() { }

  executeRecaptcha(action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      // @ts-ignore: This will suppress the TypeScript error for the 'grecaptcha' declaration
      grecaptcha.enterprise.ready(() => {
        // @ts-ignore
        grecaptcha.enterprise.execute(SecurityAccessConstants.RECAPTCHA_SITE_KEY, { action }).then((token: string) => {
          resolve(token);
        }, (error: any) => {
          reject(new Error('error'));
        });
      });
    });
  }
}
